module.exports = __webpack_public_path__ + "8c4a458dbd5c9301132504717a392abd.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2023-06-14/whats-new.html
// module id = 2342
// module chunks = 0